module.exports = __webpack_public_path__ + "img/no-sound.e1b5bca0.svg";